import MoldeModel from "@/models/moldeModel";
import PaginationModel from "@/models/paginationModel";
import { getCustomParams, getPaginationParams } from "@/utils/common/http";
import nfetch from "@/utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

class MoldeService extends iServiceCached<MoldeModel> {
    constructor() {
        super("Molde");
    }

    public async list(
        filterKey: string,
        sortKey: string,
        sortOrder: string,
        pageIndex: number,
        pageSize: number,
        customProperties: { [key: string]: any } = {},
    ) {
        const custom = getCustomParams(customProperties);
        const pagination = getPaginationParams(filterKey, sortKey, sortOrder, pageIndex, pageSize);

        return await nfetch(`/${this.controllerName}/ListMolde?${pagination}` + custom, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<PaginationModel<MoldeModel>>();
    }

    public async comboMethod() {
        const response = await nfetch(`/${this.controllerName}/ListMolde?`, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<PaginationModel<MoldeModel>>();

        return response.list;
    }

    public listFiliais(
        filterKey: string,
        sortKey: string,
        sortOrder: string,
        pageIndex: number,
        pageSize: number,
        customProperties: { [key: string]: any } = {},
    ): Promise<Response> {
        const custom = getCustomParams(customProperties);
        const pagination = getPaginationParams(filterKey, sortKey, sortOrder, pageIndex, pageSize);

        return nfetch(`/${this.controllerName}/ListFiliais?${pagination}` + custom, {
            credentials: "same-origin",
        });
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);

        return retorno.map(p => ({
            value: p.id,
            text: `${p.descricao}` + (p.ativo ? "" : " - [INATIVO]"),
            volumeInterno: p.volumeInterno,
            produtoQSPId: p.produtoQSPId,
            ativo: p.ativo,
            formasFarmaceuticasIds: p.formasFarmaceuticasIds,
        }));
    }
}

export default new MoldeService();
